import { render, staticRenderFns } from "./luckysheet.vue?vue&type=template&id=878f7b2c&scoped=true"
import script from "./luckysheet.vue?vue&type=script&lang=js"
export * from "./luckysheet.vue?vue&type=script&lang=js"
import style0 from "./luckysheet.vue?vue&type=style&index=0&id=878f7b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878f7b2c",
  null
  
)

export default component.exports